import React, { useState, useEffect } from "react";
import Buscar from "../../components/ProcesosDeCalificacion/Buscar";
import DescargarDocumentos from "../../components/ProcesosDeCalificacion/DescargarDocumentos";

import { Link, useParams } from "react-router-dom";
import { Toolbar } from "../../layout/Toolbar/Toolbar";
import { Tabla } from "../../components/Otros/Tabla";
import { PlaceholderTabla } from "../../components/Otros/Placeholder";
import { cargarDatosProceso, verProceso } from "../../utils/Datos";
import { InformacionProcesoParticipacion } from "../../components/ProcesosDeCalificacion/InformacionProcesoParticipacion";
import { ReportePrecalificadores } from "../../components/Reportes/ReportePrecalificadores";

export const ReportePage = () => {
 
        const {id_process,id_officer}=useParams();
        const [datosProceso, setDatosProceso] = useState(null);
        const [updateProceso, setUpdateProceso] = useState(true);
        const [cargandoDatos, setCargandoDatos] = useState(false);

        useEffect(() => {
            cargarDatosProceso(id_process).then((p) => {
            setCargandoDatos(false);
            setDatosProceso(p);
            setUpdateProceso(false);
            });
        }, [])

        let toolbarEnlaces = [
            {
            muted: "true",
            to: "/",
            title: "Home",
            bullet: "false",
            },
            {
            muted: "true",
            to: "",
            title: "",
            bullet: "true",
            },
            {
            muted: "false",
            to: "/buscarProceso",
            title: "Buscar Proceso de Calificación",
            bullet: "false",
            },
            {
                muted: "true",
                to: "",
                title: "",
                bullet: "true",
            },
            {
                muted: "false",
                to: "",
                title: "Reportes Proceso",
                bullet: "false",
            },
        ];

  return (
    <div
      className="content d-flex flex-column flex-column-fluid"
      id="kt_content"
    >
      <Toolbar title="REPORTES" enlaces={toolbarEnlaces} />
      <div className="post d-flex flex-column-fluid" id="kt_post">
        <div className="container-xxl">
          <div className="row gy-5 g-xl-8">
           
            <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h3 className="card-title align-items-start flex-column">
                      <span className="card-label fw-bolder text-dark">
                         INFORMACIÓN DEL PROCESO
                      </span>
                    </h3>
                  </div>

                  <div className="card-body">
                    {
                      datosProceso !=null 
                      ?
                      <InformacionProcesoParticipacion
                        key="-editar_proceso"
                        proceso={datosProceso}
                        setUpdateProceso={setUpdateProceso}
                      />
                      :
                      <center>Cargando Proceso...</center>
                    }
                    
                  </div>
                </div>
            </div>

            <div className="col-xl-12">
              <div className="card">
                <div className="card-header">
                        <h3 className="card-title align-items-start flex-column">
                        <span className="card-label fw-bolder text-dark">
                            Reporte de Precalificadores
                        </span>
                        </h3>
                </div>
                <div className="card-body">
                    <ReportePrecalificadores id_process={id_process}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

